import React from 'react';

export default function SelectedSeatLegendIcon() {
  return (
   <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
    <rect
     x="0.5"
     y="1"
     width="11"
     height="11"
     rx="0.5"
     fill="white"
     stroke="#3399FF"
    />
    <rect x="2" y="2.5" width="7.99999" height="8" rx="1" fill="#009E5E" />
   </svg>
  );
}
